import { useState } from "react";
import axios from "axios";
import { useSelector } from 'react-redux';

const getApiBaseUrl = (apiType) => {
  if (apiType === "HELPDESK") {
    return process.env.REACT_APP_HELPDESK_API_BASE_URL;
  }
  return process.env.REACT_APP_API_BASE_URL;
};
const useApi = (endpoint, method = "GET", apiType = "DEFAULT", useAuth = true) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [data, setData] = useState(null);
  const token = useSelector((state) => state.auth.employeeDetails?.token);

  const apiBaseUrl = getApiBaseUrl(apiType);

  const callApi = async (body = null, queryParams = null) => {
    setLoading(true);
    setError("");
    setData(null);

    try {
      let requestUrl = `${apiBaseUrl}${endpoint}`;

      if (queryParams) {
        const queryString = new URLSearchParams(queryParams).toString();
        requestUrl += `?${queryString}`;
      }

      // const isMultipart = requestUrl.includes("signup");

      // const headers = {
      //   "Content-Type": isMultipart ? "multipart/form-data" : "application/json",
      // };

      const isFormData = body instanceof FormData;

      const headers = {};

      if (!isFormData) {
        headers["Content-Type"] = "application/json";
      }
      

      if (useAuth && token) {
        headers["Authorization"] = `Bearer ${token}`;
      }

      const config = {
        method,
        url: requestUrl,
        headers,
      };

      if (body && ["POST", "PUT", "DELETE"].includes(method.toUpperCase())) {
        config.data = body;
      }

      const response = await axios(config);
      setData(response.data);
      return response.data;
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.response?.data?.error || err.message || "Something went wrong";
      setError(errorMessage);
      const thrownError = new Error(errorMessage);
      if (err.response?.data) thrownError.responseData = err.response.data;
      throw thrownError;
    } finally {
      setLoading(false);
    }
  };

  return { callApi, loading, error, data };
};

export default useApi;